const coursesTranslationsPrice = {
  es:{
    update: {
      breadcrumbs: {
        title: 'Editar precio',
        description: 'Modifica la configuración de precios para el curso.'
      },
      section_product: {
        title: 'Tipo de producto',
        subtitle: 'Selecciona el tipo de producto.',
        enabled: 'Habilitado',
        disabled: 'Deshabilitado',
        name: 'Nombre',
        code: 'Código',
        product: 'Producto',
        product_error: 'Debes seleccionar un producto',
      },
      codeSection: {
        title: 'Información del curso',
        subtitle: 'Seleccione el tipo de producto.',
        labels: {
          name: 'Nombre',
          code: 'Código'
        }
      },
      studentSection: {
        title: 'Tipo de estudiante'
      },
      termSection: {
        title: 'Períodos académicos',
        subtitle: 'Selecciona los períodos académicos en los que se dictará el curso.',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionados'
        }
      },
      careersSection: {
        title: 'Carreras',
        subtitle: 'Selecciona las carreras a las que se les asignará el curso.',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionadas'
        }
      },
      coursesSection: {
        title: 'Cursos',
        subtitle: 'Selecciona los cursos relacionados.',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionados'
        }
      },
      detailsSection: {
        title: 'Detalles de precios',
        table: {
          headers: {
            modalityType: 'Tipo de modalidad',
            studentType: 'Tipo de estudiante',
            zone: 'Zona',
            price: 'Precio'
          }
        }
      },
      successMessage: {
        title: 'La configuración de precios ha sido actualizada con éxito.'
      },
      errorMessage: {
        title: 'Error al actualizar la configuración de precios',
        priceConfigurationError: 'Ha ocurrido un error al obtener la configuración de los precios del curso.'
      }
    },
    validations: {
      nameRequired: 'Debes ingresar un nombre',
      nameAlphanumericWithSpaces: 'El nombre debe contener solo letras, números y espacios',
      nameMaxLength: 'El nombre no puede exceder 60 caracteres',
      codeRequired: 'Debes ingresar un código',
      codeAlphanumeric: 'El código debe contener solo letras y números',
      codeMaxLength: 'El código no puede exceder 10 caracteres',
      codeUnique: 'El código ya existe',
      studentType: 'Debes seleccionar un tipo de estudiante',
      noSelectedTerms: 'Debes seleccionar un período académico',
      noSelectedCareers: 'Debes seleccionar al menos una carrera',
      noSelectedCourses: 'Debes seleccionar al menos un curso'
    },
    table: {
      breadcrumbs: {
        title: 'Cursos',
        description: 'Administración de precios de los cursos.'
      },
      headers: {
        'name': 'Nombre',
        'code': 'Código',
        'status': 'Estado',
        'details': 'Detalles',
      },
      message: {
        delete: '¿Estás seguro de eliminar?',
        title: 'Estás a punto de eliminar las siguientes configuraciones de precios.',
        deleteAction: 'Si, eliminar',
        cancelAction: 'Cancelar',
        actions: 'Acciones'
      },
      search: {
        search: 'Buscar',
        gotopage: 'ir a página',
        edit: 'Editar',
        delete: 'Eliminar',
        bulkDelete: 'Eliminar seleccionados',
        of: 'de',
      },
      reindex: 'Reindexar',
      create: 'Nuevo',
      edit: 'Editar',
      bulk_delete: 'Eliminar seleccionados',
      bulk_delete_title: 'Eliminar configuraciones de precios seleccionadas',
      bulk_delete_confirm: '¿Estás seguro de que deseas eliminar las configuraciones de precios seleccionadas? Esta acción no se puede deshacer.',
      delete_error: 'Ocurrió un error al intentar eliminar la configuración de precios.',
    },
    create: {
      breadcrumbs: {
        title: 'Nuevo Precio',
        subtitle: 'Crea una nueva configuración de precios para el curso.'
      },
      section_product: {
        title: 'Tipo de producto',
        subtitle: 'Selecciona el tipo de producto.',
        enabled: 'Habilitado',
        disabled: 'Deshabilitado',
        name: 'Nombre',
        code: 'Código',
        new_course: 'Nuevo curso',
        new_course_description: 'Crea un nuevo curso.',
        product: 'Producto',
        product_error: 'Debes seleccionar un producto',
      },
      section_course: {
        title: 'Cursos',
        subtitle: 'Selecciona el tipo de curso.',
        study_type: 'Tipo de estudio',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionadas'
        },
        'no-selected-warning': '¡Precaución! Debes seleccionar al menos un curso.',
      },
      section_career: {
        title: 'Carreras',
        subtitle: 'Selecciona el tipo de estudio y las carreras a las que se les asignará el nuevo curso.',
        study_type: 'Tipo de estudio',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionadas'
        },
        'no-selected-warning': '¡Precaución! Debes seleccionar al menos una carrera.',
        complete_courses_first: 'Primero debes seleccionar un tipo de curso.',
        no_selected_course: '¡Precaución! Debes seleccionar al menos un curso.',

        
      },
      section_student: {
        title: 'Tipo de estudiantes',
        error: '¡Precaución! Debes seleccionar al menos un tipo de estudiante.',
      },
      section_modality: {
        title: 'Modalidades',
        error: '¡Precaución! Debes seleccionar al menos una modalidad.',
      },
      section_zone: {
        title: 'Precios y regiones',
        items: {
          zone: 'Región',
          zone_error: 'Debes seleccionar una región',
          price: 'Precio',
          price_error: 'Debes ingresar un número',
        },
        new_zone: 'Nueva región',
        new_zone_description: 'Crea una nueva región.'
      },
      section_periods: {
        title: 'Períodos',
        subtitle: 'Selecciona los períodos académicos en los que se dictará el curso.',
        firstTitle: 'Períodos Disponibles',
        secondTitle: 'Períodos Seleccionados',
        transferList: {
          firstTitle: 'Disponibles',
          secondTitle: 'Seleccionados'
        },
        'no-selected-warning': '¡Precaución! Debes seleccionar un período académico.'
      },
      buttons: {
        error: 'Error',
        create: 'Crear',
        created: 'Creado',
        cancel: 'Cancelar'
      },
      warning_popup: {
        title: '¿Deseas crear una configuración de precios en estado deshabilitado?',
      },
      success_title: 'La configuración de precios ha sido creada con éxito.',
      error_title: 'Ya existe una configuración de precios relacionada al producto y fecha seleccionados.',
      data_loading_error: 'Ha ocurrido un error al cargar los datos necesarios para crear el curso.',
      accept: 'Aceptar',
      go_to_back:'Volver',
    },
  },
  en:{

  }
}

export default coursesTranslationsPrice